import { Link } from 'react-router-dom'
import { Building2, Package, ClipboardList } from 'lucide-react'

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Link to="/companies" className="card hover:shadow-md transition-shadow flex items-center gap-4">
          <Building2 className="w-8 h-8 text-brand" />
          <div>
            <div className="font-semibold text-gray-800">Companies</div>
            <div className="text-xs text-gray-500">Clients &amp; their product cards</div>
          </div>
        </Link>
        <Link to="/products" className="card hover:shadow-md transition-shadow flex items-center gap-4">
          <Package className="w-8 h-8 text-brand" />
          <div>
            <div className="font-semibold text-gray-800">Products</div>
            <div className="text-xs text-gray-500">Master product list</div>
          </div>
        </Link>
        <Link to="/orders" className="card hover:shadow-md transition-shadow flex items-center gap-4">
          <ClipboardList className="w-8 h-8 text-brand" />
          <div>
            <div className="font-semibold text-gray-800">Orders</div>
            <div className="text-xs text-gray-500">Place &amp; track orders</div>
          </div>
        </Link>
      </div>
      <div className="card">
        <h3 className="font-semibold text-gray-800 mb-2">Recent orders</h3>
        <p className="text-sm text-gray-500">Orders feed will appear here once the orders module is wired up.</p>
      </div>
    </div>
  )
}
